// web-ctr/src/components/ui/Modal.jsx
// Plain fixed-position modal (no portal library): scrim at the census value
// rgba(15,23,42,0.45) via bg-ink/45, panel per Dashboard.dc.html. Escape and
// scrim-click close. Never a native browser dialog.
import { useEffect } from 'react';

export default function Modal({ open, onClose, maxWidth = 'max-w-[560px]', children }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-ink/45 p-4"
      onMouseDown={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
      role="dialog"
      aria-modal="true"
    >
      <div className={`w-full ${maxWidth} rounded-modal bg-white p-[30px] shadow-modal`}>
        {children}
      </div>
    </div>
  );
}
